"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _base = require("./base");

var _NavSearch = _interopRequireDefault(require("./NavSearch"));

var _NavLinksCreate = _interopRequireDefault(require("./NavLinksCreate"));

var _NavLinksCollection = _interopRequireDefault(require("./NavLinksCollection"));

var _NavLinksUser = _interopRequireDefault(require("./NavLinksUser"));

var _icons = _interopRequireDefault(require("../styles/icons"));

var _theme = require("../styles/theme");

var _themeNav = require("./theme-nav");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NavTouchIcon = ( /*#__PURE__*/0, _styledBase.default)('div', {
  target: "e1h2vgca0",
  label: "NavTouchIcon"
})("display:none;padding:0 20px;text-align:center;position:absolute;left:0px;&::after{", _theme.fonts.icons, ";content:'", function (_ref) {
  var mobilemenu = _ref.mobilemenu;
  return mobilemenu ? _icons.default.x : _icons.default['touch-nav'];
}, "';color:", _themeNav.navItemColor, ";line-height:", _themeNav.navHeight, ";font-size:", _theme.fonts.sans.size.xlarge, ";}&:hover{cursor:pointer;&::after{color:", _themeNav.navItemHoverColor, ";}}@media screen and (max-width:1000px){display:block;& + ", _base.NavInnerWrapper, "{right:", function (_ref2) {
  var mobilemenu = _ref2.mobilemenu;
  return mobilemenu ? 0 : '-220px';
}, ";}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var NavTouch = /*#__PURE__*/function (_Component) {
  _inherits(NavTouch, _Component);

  var _super = _createSuper(NavTouch);

  function NavTouch(props) {
    var _this;

    _classCallCheck(this, NavTouch);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleMenu", function () {
      var mobilemenu = _this.state.mobilemenu;
      var toggleState = !mobilemenu;

      _this.setState({
        mobilemenu: toggleState
      });
    });

    _this.state = {
      mobilemenu: props.mobilemenu || false
    };
    return _this;
  }

  _createClass(NavTouch, [{
    key: "render",
    value: function render() {
      var otherProps = _extends({}, this.state);

      return /*#__PURE__*/_react.default.createElement(NavTouchIcon, _extends({
        onClick: this.toggleMenu
      }, otherProps));
    }
  }]);

  return NavTouch;
}(_react.Component);

NavTouch.defaultProps = {
  mobilemenu: false,
  onChange: function onChange() {}
};
NavTouch.propTypes = {
  mobilemenu: _propTypes.default.bool,
  onChange: _propTypes.default.func
};

var Nav = function Nav(props) {
  var basic = props.basic,
      align = props.align,
      theme = props.theme,
      onSearch = props.onSearch,
      searchPlaceholder = props.searchPlaceholder,
      ready = props.ready,
      avatarUrl = props.avatarUrl,
      _props$data = props.data,
      primaryLinks = _props$data.primaryLinks,
      createLinks = _props$data.createLinks,
      secondaryLinks = _props$data.secondaryLinks,
      userLinks = _props$data.userLinks;

  var isEmpty = function isEmpty(arr) {
    return Array.isArray(arr) && arr.every(isEmpty);
  };

  var createLinksExist = function createLinksExist() {
    return !isEmpty(createLinks);
  };

  return /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, {
    theme: {
      mode: theme
    }
  }, /*#__PURE__*/_react.default.createElement(_base.NavWrapper, {
    ready: ready,
    theme: {
      mode: theme
    }
  }, /*#__PURE__*/_react.default.createElement(NavTouch, null), /*#__PURE__*/_react.default.createElement(_base.NavInnerWrapper, {
    align: align
  }, basic ? /*#__PURE__*/_react.default.createElement(_NavLinksCollection.default, {
    links: secondaryLinks,
    theme: {
      mode: theme
    }
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_NavLinksCollection.default, {
    links: primaryLinks,
    mobileorder: "4",
    theme: {
      mode: theme
    }
  }), /*#__PURE__*/_react.default.createElement(_NavSearch.default, {
    onSearch: onSearch,
    placeholder: searchPlaceholder,
    mobileorder: "1",
    theme: {
      mode: theme
    }
  }), createLinksExist(createLinks) && /*#__PURE__*/_react.default.createElement(_NavLinksCreate.default, {
    links: createLinks,
    mobileorder: "3",
    theme: {
      mode: theme
    }
  }), /*#__PURE__*/_react.default.createElement(_NavLinksCollection.default, {
    links: secondaryLinks,
    mobileorder: "4",
    theme: {
      mode: theme
    }
  }), /*#__PURE__*/_react.default.createElement(_NavLinksUser.default, {
    links: userLinks,
    avatarUrl: avatarUrl,
    mobileorder: "1",
    theme: {
      mode: theme
    }
  })))));
};

var linkShape = _propTypes.default.shape({
  name: _propTypes.default.string,
  path: _propTypes.default.string,
  children: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape({
    name: _propTypes.default.string,
    path: _propTypes.default.string
  }), _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    path: _propTypes.default.string
  }))]))
});

var linkCollectionShape = _propTypes.default.arrayOf(_propTypes.default.oneOfType([linkShape, _propTypes.default.arrayOf(linkShape)]));

Nav.defaultProps = {
  basic: false,
  align: 'left',
  theme: 'default',
  ready: true,
  avatarUrl: undefined,
  onSearch: null,
  searchPlaceholder: ''
};
Nav.propTypes = {
  basic: _propTypes.default.bool,
  align: _propTypes.default.string,
  theme: _propTypes.default.string,
  ready: _propTypes.default.bool,
  onSearch: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  searchPlaceholder: _propTypes.default.string,
  data: _propTypes.default.shape({
    primaryLinks: linkCollectionShape.isRequired,
    createLinks: linkCollectionShape.isRequired,
    secondaryLinks: linkCollectionShape.isRequired,
    userLinks: linkCollectionShape.isRequired
  }).isRequired,
  avatarUrl: _propTypes.default.string
};
var _default = Nav;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/nav/Nav.js
// module id = 746
// module chunks = 0 15 16 17 18